import React from 'react';
import { ComposableModal, ModalContent, ModalFooter } from '#app/components/ModalForm';
import { Button } from 'finform';
import { Row } from '#app/pages/styles';
import Register from '../../../../pages/Auth/Register';

const RegisterModal = ({ show, handleCloseModal, handleLoginModal, i18n }) => (
  <ComposableModal
    size="extra-small"
    show={show}
    trigger=""
    title={i18n.auth?.register}
    onClose={handleCloseModal}
    closeButtonVariant="landing"
  >
    <ModalContent>
      <Register />
    </ModalContent>
    <ModalFooter>
      <Row>
        <Button
          wide
          type="cancel"
          id="login-modal-button"
          onClick={(e) => {
            e.preventDefault();
            handleLoginModal();
          }}
        >
          {i18n.auth?.enter}
        </Button>
      </Row>
    </ModalFooter>
  </ComposableModal>
);

export default RegisterModal;
